export { UniversityCardDetail } from "./UniversityCardDetail";
